var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
/** A primitive icon component to simplify the use of Quinine icons. The icon color is determined by the value of the CSS color property, so by default it will match the color of surrounding text. */
export const QuiIcon = forwardRef((_a, ref) => {
    var { size, color, icon, className, style } = _a, otherProps = __rest(_a, ["size", "color", "icon", "className", "style"]);
    const iconClassName = classNames(`qui-icon-${icon}`, {
        [`qui-size-${size}`]: typeof size !== "number" && size !== undefined,
        [`qui-color-${color}`]: !!color,
    }, className);
    const iconSizeStyling = typeof size === "number" ? { width: `${size}px`, height: `${size}px` } : undefined;
    return React.createElement("i", Object.assign({ className: iconClassName, ref: ref, style: Object.assign(Object.assign({}, style), iconSizeStyling) }, otherProps));
});
QuiIcon.displayName = "QuiIcon";
